var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroww({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #4e68ff;\n      }\n\n      .st1 {\n        fill: #00f6b6;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.23,147.97c40.31-9.52,65.27-49.9,55.75-90.2C138.46,17.47,98.07-7.49,57.77,2.02,17.47,11.54-7.49,51.93,2.02,92.23c9.52,40.3,49.91,65.26,90.2,55.74Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.98,57.77c-1.36-5.77-3.35-11.21-5.88-16.3l-.02.02-47.22,43.65c-2.95,2.73-7.34,3.2-10.81,1.17l-20.07-11.75c-3.25-1.89-7.32-1.61-10.26.72-12.43,9.84-44.26,35.01-44.71,35.38,15.7,29.11,49.48,45.29,83.22,37.31,40.31-9.52,65.27-49.9,55.75-90.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroww);
export default __webpack_public_path__ + "static/media/Groww.d8df53a91c5679767d5b2483f8f634a7.svg";
export { ForwardRef as ReactComponent };